import React, { useContext } from 'react';
import { Box, Card as MUICard, Typography } from '@material-ui/core';

import type { IOrderDetails } from 'pages/orderHistoryDetails/hooks/useOrderDetails';
import { AuthContext } from 'contexts/AuthContext';

import { css } from './styles';

interface ICardProps {
  orderDetails: IOrderDetails;
}

export const formatDiscount = (value: number) => {
  if (value === null) {
    return 'R$ 0,00';
  }

  return `R$ ${value.toFixed(2)}`;
};

export const Card = ({ orderDetails }: ICardProps) => {
  const styles = css();

  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);

  return orderDetails ? (
    <MUICard className={styles.card}>
      <Box marginBottom="8px">
        <Typography variant="h6">Número do pedido: {orderDetails.purchaseOrderId}</Typography>
        <Typography>DESCRIÇÃO: {orderDetails.productName}</Typography>
      </Box>

      <Box display="flex" gridGap="220px">
        <Box gridGap="4px">
          <Typography>ID Produto: {orderDetails.productId}</Typography>
          <Typography>Código numérico: {orderDetails.numericCode}</Typography>
          <Typography>Cor: {orderDetails.colorAbbreviation}</Typography>
          <Typography>Código alfa: {orderDetails.alphaId}</Typography>
          <Typography>Status: {orderDetails.statusDescription}</Typography>
        </Box>

        <Box>
          {isVisaoTok && (
            <>
              <Typography>ID Fornecedor: {orderDetails.personId}</Typography>
              <Typography>Fornecedor: {orderDetails.personalName}</Typography>
            </>
          )}
          <Typography>OTIF: {orderDetails.otifValue}</Typography>

          <Typography>Total Penalização No Show: {formatDiscount(orderDetails.monetaryDiscountNoShow)}</Typography>

          <Typography>
            Total Penalização Entrega Tardia: {formatDiscount(orderDetails.monetaryDiscountScheduleChange)}
          </Typography>
        </Box>
      </Box>
    </MUICard>
  ) : null;
};
